import { Grid, Stack, Typography, Checkbox, useMediaQuery } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { UAParser } from "ua-parser-js";
import ImageAssets from "../../../../assets";
import MuiStepper from "../../../../components/common/stepper/MuiStepper";
import { addUserSkillsRequest, draftUserData, getAllCategoriesRequest } from "../../../../redux/login-redux/LoginRedux";
import strings from "../../../../strings/Strings";
import { CreateUserStepperEnumUtils } from "./EmailVerification";
import styles from "./style.module.css";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

const PersonalisationV1 = ({ activeStep, setActiveStep }) => {

    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const steps = CreateUserStepperEnumUtils.getCreateUserStepperEnums();

    const isMobile = useMediaQuery("(max-width: 839px)");

    const loginState = useSelector((state: any) => state.Login);
    const storeDraftUserData = loginState?.draftUserData;

    const allCategories = [
        {
            "id": "bd6d2c4a-1b91-4f14-944f-73b41a395a7c",
            "name": "Writing",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115548359ZUTCIMG_2180.PNG",
            "noOfSkills": 11,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T09:57:12.128Z",
            "updatedAt": "2024-10-23T12:50:10.379Z"
        },
        {
            "id": "49fa9fe1-1a9b-412e-b9e3-dfbe76af6640",
            "name": "Fashion",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115604706ZUTCIMG_2182.PNG",
            "noOfSkills": 14,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T09:54:36.258Z",
            "updatedAt": "2024-10-23T12:50:29.237Z"
        },
        {
            "id": "c92d620b-de92-4820-a306-954bf71cd1c9",
            "name": "Dance",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115615347ZUTCIMG_2183.PNG",
            "noOfSkills": 17,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T09:50:39.018Z",
            "updatedAt": "2024-10-23T12:50:40.785Z"
        },
        {
            "id": "bf883499-5574-4e3a-9c21-457cbe7a6ee0",
            "name": "Photography",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115633363ZUTCIMG_2186.PNG",
            "noOfSkills": 13,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T09:45:56.929Z",
            "updatedAt": "2024-10-23T12:50:53.251Z"
        },
        {
            "id": "5d74f0a6-65e5-466a-b85b-37edae42e5ad",
            "name": "Visual Arts & Crafts",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115643345ZUTCIMG_2179.PNG",
            "noOfSkills": 18,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T08:13:42.646Z",
            "updatedAt": "2024-10-23T12:51:09.247Z"
        },
        {
            "id": "b36c8a03-7c5d-446e-b6ba-ebe197020ab4",
            "name": "Film and Theatre",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115653333ZUTCIMG_2184.PNG",
            "noOfSkills": 24,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": "4b44b741-57f2-49cb-a17a-d9b0ba88ae5d",
            "createdAt": "2024-10-23T08:07:23.973Z",
            "updatedAt": "2024-10-23T12:51:34.669Z"
        },
        {
            "id": "ce92c296-9cfc-42bd-9389-ddc667f3c5ee",
            "name": "Music",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115701663ZUTCIMG_2178.PNG",
            "noOfSkills": 33,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T07:03:41.934Z",
            "updatedAt": "2024-10-23T12:51:49.593Z"
        },
        {
            "id": "7993eacd-c6d9-4a4d-9f89-d0038b900390",
            "name": "Design and Animation",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115427364ZUTCIMG_2185.PNG",
            "noOfSkills": 14,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T10:09:56.153Z",
            "updatedAt": "2024-11-18T10:31:25.998Z"
        },
        {
            "id": "32c638d4-ad2e-4809-85bd-212504257d03",
            "name": "Content Creation",
            "imageUrl": "https://sekeron-medias.s3.ap-south-1.amazonaws.com/20250207T115536823ZUTCIMG_2181.PNG",
            "noOfSkills": 4,
            "createdBy": "b207d207-8ae8-4708-a010-d22a379d47c8",
            "updatedBy": null,
            "createdAt": "2024-10-23T09:58:44.843Z",
            "updatedAt": "2025-01-12T08:12:36.633Z"
        }
    ];

    const [categories, setCategories] = useState([]);
    const [deviceInfo, setDeviceInfo] = useState({
        device: "",
        os: "",
        browser: "",
    });

    const [ipAddress, setIpAddress] = useState("");
    const [userLocation, setLocation] = useState({
        latitude: 28.6425088,
        longitude: 77.2126422,
    });

    useEffect(() => {
        const fetchIpAddress = async () => {
            try {
                const response = await axios.get("https://ipinfo.io/json");
                setIpAddress(response.data.ip);
            } catch (error) {
                console.error("Error fetching the IP address:", error);
            }
        };

        fetchIpAddress();
    }, []);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (err) => {
                    console.log(err.message);
                }
            );
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, []);

    useEffect(() => {
        const parser = new UAParser();
        const result = parser.getResult();
        setDeviceInfo({
            device: result.device.model || "Unknown Device",
            os: result.os.name || "Unknown OS",
            browser: result.browser.name || "Unknown Browser",
        });
    }, []);

    useEffect(() => {
        dispatch(getAllCategoriesRequest());
    }, [])

    const handleCheckBox = (id: any) => {
        let array = [...(storeDraftUserData?.categories || [])];
        if (array.includes(id)) {
            let index = array?.indexOf(id);
            array.splice(index, 1);
        }
        else {
            array.push(id);
        }
        dispatch(draftUserData({
            ...storeDraftUserData,
            "categories": [...array],
        }))
        // setCategories([...array]);
    }

    const handleLetsGetStarted = () => {

        const dob = storeDraftUserData?.dob;

        // Convert dob to a valid Day.js instance
        const formattedDOB = dayjs(dob?.$d || dob).format("YYYY-MM-DD");

        let reqBody = {
            dob: formattedDOB?.toString(),
            city: storeDraftUserData?.city,
            userName: storeDraftUserData?.userName,
            phoneNumber: storeDraftUserData?.phoneNumber,
            countryCode: storeDraftUserData?.countryCode,
            skillIds: storeDraftUserData?.skillIds,
            categoryIds: storeDraftUserData?.categories,
            ipAddress: ipAddress,
            latitude: userLocation?.latitude,
            longitude: userLocation?.longitude,
            channelType: 2,
            deviceId: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
            deviceName: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
        }
        dispatch(addUserSkillsRequest(reqBody));
        navigate("/home");
    }

    const handleSkip = () => {

        const dob = location?.state?.dob;

        // Convert dob to a valid Day.js instance
        const formattedDOB = dayjs(dob?.$d || dob).format("YYYY-MM-DD");

        let reqBody = {

            dob: formattedDOB?.toString(),
            city: storeDraftUserData?.city,
            userName: storeDraftUserData?.userName,
            phoneNumber: storeDraftUserData?.phoneNumber,
            countryCode: storeDraftUserData?.countryCode,
            skillIds: storeDraftUserData?.skillIds,
            categoryIds: [],
            ipAddress: ipAddress,
            latitude: userLocation?.latitude,
            longitude: userLocation?.longitude,
            channelType: 2,
            deviceId: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
            deviceName: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
        }
        dispatch(addUserSkillsRequest(reqBody));
        navigate("/home");
    }

    const handleStepClick = (index: number) => {
        if (activeStep === 2) {
            setActiveStep(index);
        }
    };

    return (
        <>
            <div style={{ position: 'relative' }} className={styles["form-container"]}>
                <div className={styles["registration-form-container"]}>

                    <div className={styles["stepper-container"]}>
                        <Stack flexDirection={"row"} gap={isMobile ? 4 : 10} width={'100%'} alignItems={'center'}>
                            <ArrowBackIosRoundedIcon
                                onClick={() => setActiveStep(1)}
                                className={styles["back-button"]}
                            />
                            <div style={{ width: '60%' }}>
                                <MuiStepper
                                    activeStep={activeStep}
                                    steps={steps}
                                    handleStepClick={handleStepClick}
                                />
                            </div>
                        </Stack>
                    </div>

                    <Typography className={styles["card-container-heading"]}>
                        {strings.selectWhatAmusesYou}
                    </Typography>
                    <div className={styles["cards-container"]}>
                        {loginState?.allCategories?.length > 0 &&
                            loginState?.allCategories?.slice(0, 9)?.map((Contents: any) => {
                                return (
                                    <div className={styles[storeDraftUserData?.categories?.includes(Contents?.id) ? "card-selected" : "activitycard"]} onClick={() => handleCheckBox(Contents?.id)}>
                                        <img src={Contents?.imageUrl} alt="hai" style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.8rem' }} />
                                    </div>
                                );
                            })}
                    </div>
                    <Stack gap={2} alignItems={'center'} flexDirection={'row'} justifyContent={'center'} justifySelf={'center'} marginBottom={'4rem'} marginTop={'4rem'} >

                        <button className={styles["lets-get-start-button"]}
                            onClick={handleSkip}
                            style={{ backgroundColor: 'var(--secondary-theme-color)', backgroundImage: 'none', borderWidth: '1px', borderColor: '#576078', borderStyle: 'solid' }}>
                            Skip
                        </button>

                        <button className={styles["lets-get-start-button"]}
                            disabled={storeDraftUserData?.categories?.length > 0 ? false : true}
                            onClick={handleLetsGetStarted}
                        >
                            Explore Home
                        </button>

                    </Stack>
                </div>
            </div>
        </>
    );
};

export default PersonalisationV1;
